import { TiTick } from "react-icons/ti";
import TickIcon from "../../../assets/images/png/tickIcon.png";

import CONSTANTS from "../../../utils/constants/CONSTANTS";

import "./index.scss";

const FeatureBox = ({ heading, featureDetails }) => (
  <div className="feature-box">
    <div className="tick-icon">
      <img className="tick-img" src={TickIcon} alt="tick img" />
    </div>
    <div className="feature-data">
      <h3 className="feature-heading">{heading}</h3>
      <p className="feature-details">{featureDetails}</p>
    </div>
  </div>
);

export default FeatureBox;
